module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/as0607-aa2bc52702ce6e6980411a982330fe34.jpg";